import {domains} from '../../constants/Utils';
import {aseWebsocketCommands} from '../../constants/aseWebsocketCommands';

export const ADMIN_WORKING_HOURS_FETCH_PENDING = 'ADMIN_WORKING_HOURS_FETCH_PENDING';
export const ADMIN_WORKING_HOURS_SAVE_PENDING = 'ADMIN_WORKING_HOURS_SAVE_PENDING';
export const ADMIN_WORKING_HOURS_RESET = 'ADMIN_WORKING_HOURS_RESET';
export const ADMIN_WORKING_HOURS_UPDATE = 'ADMIN_WORKING_HOURS_UPDATE';
export const ADMIN_WORKING_HOURS_SELECT_GROUP = 'ADMIN_WORKING_HOURS_SELECT_GROUP';

export const storeSelectedCountryGroup = countryGroup => dispatch =>
    dispatch({
        type: ADMIN_WORKING_HOURS_SELECT_GROUP,
        payload: countryGroup
    });

export function updateWorkingHours(day, values) {
    return {
        type: ADMIN_WORKING_HOURS_UPDATE,
        payload: {day, values},
    };
}

export function resetWorkingHours() {
    return {
        type: ADMIN_WORKING_HOURS_RESET,
    };
}

export const fetchWorkingHoursData = ({domain, group}) => dispatch => {
    switch (domain) {
        case domains.ASE: {
            return dispatch({
                type: ADMIN_WORKING_HOURS_FETCH_PENDING,
                aseWebsocket: true,
                command: aseWebsocketCommands.ASE_WORKING_HOURS_GET,
                payload: {group}
            });
        }
    }
};

export const storeWorkingHours = ({domain, workingHours}) => dispatch => {
    switch (domain) {
        case domains.ASE: {
            return dispatch({
                type: ADMIN_WORKING_HOURS_SAVE_PENDING,
                aseWebsocket: true,
                command: aseWebsocketCommands.ASE_WORKING_HOURS_SET,
                payload: {workingHours}
            });
        }
    }
}
